import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

// Renders grouped FAQ data into clean accordions.
export const FAQAccordion = ({ categories, single = false }) => {
  // When single=true, render a flat list (used for the home summary).
  if (single) {
    return (
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {categories.map((item, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
            <AccordionTrigger
              data-testid={`faq-q-${i}`}
              className="py-5 text-left font-heading text-base font-medium text-ink hover:text-brand hover:no-underline"
            >
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-base leading-relaxed text-ink-soft">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    );
  }

  return (
    <div className="space-y-12" data-testid="faq-accordion">
      {categories.map((cat, ci) => (
        <div key={ci} data-testid={`faq-category-${ci}`}>
          <h3 className="mb-2 font-heading text-xl font-semibold text-brand">{cat.category}</h3>
          <Accordion type="single" collapsible className="w-full">
            {cat.items.map((item, i) => (
              <AccordionItem key={i} value={`c${ci}-i${i}`} className="border-b border-border">
                <AccordionTrigger
                  data-testid={`faq-q-${ci}-${i}`}
                  className="py-5 text-left font-heading text-base font-medium text-ink hover:text-brand hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-base leading-relaxed text-ink-soft">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      ))}
    </div>
  );
};
